import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { media, mixins } from '@blend/consumer-components';
import { utils } from '@blend/ui-common';

import Emblem from 'login-components/Emblem/Emblem';
import SignOutButton from 'login-components/Common/SignOutButton/SignOutButton';
import * as userUtils from 'login-utils/userUtils';
import * as featureFlags from 'login-utils/featureFlags';
import BackToPreviousApplicationButton from 'login-components/Common/BackToPreviousApplicationButton/BackToPreviousApplicationButton';

const styles = StyleSheet.create({
  mastheadWrapper: {
    ...mixins.margin('3%', 0, '2.5%', 0),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'wrap',
  },
  masthead: {
    width: '60%',
    display: 'flex',
    justifyContent: 'center',
    [media.mobileMedium]: {
      order: 3,
      ...mixins.margin(10, 0, 0, 0),
      width: '100%',
    },
  },
  topButton: {
    width: '20%',
    display: 'flex',
    [media.mobileMedium]: {
      width: '50%',
    },
  },
  signOutButton: {
    justifyContent: 'flex-end',
  },
  backButton: {
    justifyContent: 'flex-start',
  },
});

export default class Masthead extends React.PureComponent {
  render() {
    const displaySignoutButton =
      !!userUtils.getCurrentUser() && featureFlags.isEnabled('signoutButtonOnMoreLoginPages20190912');
    const displayBackButton =
      !!utils.cookieUtils.get('previousSelectedProductId') &&
      featureFlags.isEnabled('signoutButtonOnMoreLoginPages20190912');

    return (
      <div className={css(styles.mastheadWrapper)}>
        <div className={css(styles.topButton, styles.backButton)}>
          {displayBackButton && <BackToPreviousApplicationButton />}
        </div>
        <div className={css(styles.masthead)}>
          <Emblem />
        </div>
        <div className={css(styles.topButton, styles.signOutButton)}>
          {displaySignoutButton && <SignOutButton buttonText="Sign Out" />}
        </div>
      </div>
    );
  }
}
